import type { ReactNode } from 'react';

/** The account-entry screen: one centred panel on a muted page. */
export function EntryScreen({ children }: { children: ReactNode }) {
  return (
    <main className="flex min-h-svh flex-col items-center justify-center gap-6 bg-muted p-6">
      {children}
    </main>
  );
}
